import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { insightsAtlas, insightsNode } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { UiRoutes } from '@lsq-frontend/angular-shared/app-constants';
import { InsightsOverviewComponent } from './overview/insights-overview.component';
import { CustomersByExposureComponent } from './customers-by-exposure/customers-by-exposure.component';
import { InsightsComponent } from './insights.component';
import { ClaimGuard, FeatureFlagGuard, Routes } from '@lsq-frontend/common-ui';

export const insightsRoutes: Routes = [
    {
        path: UiRoutes.Home,
        component: InsightsComponent,
        children: [
            {
                path: UiRoutes.Home,
                component: InsightsOverviewComponent,
                canActivate: [ClaimGuard, FeatureFlagGuard],
                data: {
                    title: insightsNode.title,
                    featureFlags: insightsNode.featureFlags,
                    claims: insightsNode.claims
                }
            },
            {
                path: insightsAtlas.INSIGHTS_CUSTOMERS_BY_EXPOSURE.path,
                component: CustomersByExposureComponent,
                canActivate: [ClaimGuard, FeatureFlagGuard],
                data: {
                    title: insightsAtlas.INSIGHTS_CUSTOMERS_BY_EXPOSURE.title,
                    featureFlags: insightsNode.children.INSIGHTS_CUSTOMERS_BY_EXPOSURE.featureFlags,
                    claims: insightsNode.children.INSIGHTS_CUSTOMERS_BY_EXPOSURE.claims
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(insightsRoutes)],
    exports: [RouterModule]
})
export class InsightsRoutingModule {}
